import { useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useURLParams = () => {
  const param = useParams();
  const location = useLocation();
  const params = useRef<any>({});
  const query = useRef<any>({});

  Object.keys(param).forEach(key => {
    params.current[key] = param[key] || '';
  });

  const searchParams = new URLSearchParams(location.search);
  searchParams.forEach((value, key) => {
    query.current[key] = value;
  });

  return { params: params.current, query: query.current };
};

export default useURLParams;
